import type { GetProjectsQueryParams } from './getProjectsOverrides';
import { querySerializer as querySerializer_ } from './getProjectsOverrides';

export interface GetFlagCountsForProjectsQueryParams extends GetProjectsQueryParams {}

export function querySerializer(queryParams: GetFlagCountsForProjectsQueryParams) {
  return querySerializer_(queryParams);
}
